export const messageCharacterSizeLimit = 10_000
